import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'modal', 'disable']

  toggle() {
    $(this.modalTarget.value).modal(this.checkboxTarget.checked ? 'show' : 'hide');
    this.disableTarget.disabled = !this.checkboxTarget.checked;
  }
}
